export default "__VITE_ASSET__CWaJEWir__ 100w";